import { FormHelperText, Grid } from "@material-ui/core";
import React, { Component, Fragment } from "react";
import { Prompt } from "react-router";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import { userFarmDetail } from "../../../config/farmDetails";
import { userDetail } from "../../../config/userDetails";
import DropdownOptions from "../../../constants/DropdownOptions";
import { disableEditRole } from "../../Common/CheckAuthorization";
import Button from "../../FormElement/Button";
import Dropdown from "../../FormElement/Dropdown";
import { validForm } from "../../FormElement/FormValidator";
import InputFiled from "../../FormElement/InputFiled";
import { subscriptionPlan } from "../../../constants/UserAttributes";

const signInSectionStyle = {
  display: "flex",
  alignItems: "baseline",
  justifyContent: "space-between"
};

const NO_UPDATE = "0";
const UPGRADE_PLAN = "1";
const UPDATE_PLAN = "2";
const RENEW_PLAN = "3";

class AllUsersForm extends Component {
  constructor(props) {
    super(props);
    const { userInfo, SubFarmId, MainFarmId } = props;
    this.state = {
      userInfo: {
        farmId: userInfo
          ? userInfo.farmId
          : SubFarmId || userFarmDetail().id || MainFarmId,
        firstName: userInfo ? userInfo.firstName : null,
        lastName: userInfo ? userInfo.lastName : null,
        username: userInfo ? userInfo.username : null,
        password: userInfo ? userInfo.password : null,
        confirmPassword: userInfo ? userInfo.confirmPassword : null,
        role: userInfo ? userInfo.roleName : "FARM_EMPLOYEE",
        modifyPlan: NO_UPDATE,
        noOfContracts: "",
        noOfLogins: "",
        noOfTickets: "",
        subscriptionId: ""
      },
      formErrors: {
        firstName: "",
        lastName: "",
        username: "",
        password: "",
        role: ""
      },
      isInvalid: true,
      edited: false
    };
  }

  handleChange = event => {
    if (!this.state.edited) this.setState({ edited: true });
    const { name, value } = event.target;
    if (name === "firstName" || name === "lastName") {
      if (value.match(/^(\w|\ ){0,51}$/)) {
        this.updateState(name, value);
      }
    } else if (
      name === "noOfContracts" ||
      name === "noOfTickets" ||
      name === "noOfLogins"
    ) {
      if (value.match(/^\d{0,4}?$/)) {
        this.updateState(name, value);
      }
    } else {
      this.updateState(name, value);
    }
  };

  updateState = (name, value) => {
    this.setState(
      prevState => {
        return {
          userInfo: {
            ...prevState.userInfo,
            [name]: value
          }
        };
      },
      () => {
        const { userInfo } = this.state;
        const { editMode } = this.props;
        const requiredFields = { ...userInfo };
        if (editMode) {
          delete requiredFields.password;
          delete requiredFields.confirmPassword;
          delete requiredFields.noOfContracts;
          delete requiredFields.noOfTickets;
          delete requiredFields.noOfLogins;
          delete requiredFields.subscriptionId;
        }
        this.validateAll(requiredFields);
      }
    );
  };

  handleError = (name, error) => {
    this.setState(
      prevState => {
        return {
          formErrors: {
            ...prevState.formErrors,
            [name]: error
          }
        };
      },
      () => {
        const { userInfo } = this.state;
        const { editMode } = this.props;
        const requiredFields = { ...userInfo };
        if (editMode) {
          delete requiredFields.password;
          delete requiredFields.confirmPassword;
          delete requiredFields.noOfContracts;
          delete requiredFields.noOfTickets;
          delete requiredFields.noOfLogins;
          delete requiredFields.subscriptionId;
        }
        this.validateAll(requiredFields);
      }
    );
  };

  validateAll = formFields => {
    this.setState({
      isInvalid: validForm(this.state.formErrors, formFields)
    });
  };

  componentDidUpdate = () => {
    if (this.state.edited) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = undefined;
    }
  };

  componentWillUnmount() {
    window.onbeforeunload = undefined;
  }

  validateResetForm = () => {
    const { password, confirmPassword } = this.state.userInfo;
    if (confirmPassword !== "" || confirmPassword !== null)
      return password === confirmPassword;
    else return true;
  };

  checkUpdatePlanStatus = () => {
    const { modifyPlan, subscriptionId } = this.state.userInfo;
    const { noOfContracts, noOfLogins, noOfTickets } = this.state.userInfo;
    if (modifyPlan == UPDATE_PLAN) {
      return noOfContracts || noOfTickets || noOfLogins;
    } else if (modifyPlan == UPGRADE_PLAN) {
      return subscriptionId;
    } else {
      return true;
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    this.setState({ isInvalid: true, edited: false });
    const { userInfo } = this.state;
    const formData = { ...userInfo };
    formData.modifyPlan = parseInt(formData.modifyPlan);
    formData.noOfContracts = parseInt(formData.noOfContracts) || 0;
    formData.noOfTickets = parseInt(formData.noOfTickets) || 0;
    formData.noOfLogins = parseInt(formData.noOfLogins) || 0;
    formData.subscriptionId = parseInt(formData.subscriptionId);
    delete formData.subscriptionId;
    if (formData.modifyPlan == UPDATE_PLAN) {
      formData.updatePlan = [
        { licensePropertyId: 1, incrementedValue: formData.noOfContracts },
        { licensePropertyId: 2, incrementedValue: formData.noOfTickets },
        { licensePropertyId: 3, incrementedValue: formData.noOfLogins }
      ];
    }
    if (formData.modifyPlan == UPGRADE_PLAN) {
      formData.planId = userInfo.subscriptionId;
    }
    delete formData.noOfContracts;
    delete formData.noOfTickets;
    delete formData.noOfLogins;
    delete formData.confirmPassword;
    delete formData.password;
    console.log(formData);
    this.props.handleSubmit(formData);
  };

  isEnterpriseUser = () => {
    const { subscriptionId } = this.props.userInfo;
    return subscriptionId === 4 || subscriptionId === 3;
  };

  render() {
    const availableUpgradeOption = subscriptionPlan.filter(
      list => list.id > this.props.userInfo.subscriptionId
    );

    const { farmId, firstName, lastName, username } = this.state.userInfo;
    const { password, role, confirmPassword, modifyPlan } = this.state.userInfo;
    const { noOfContracts, noOfTickets, noOfLogins } = this.state.userInfo;
    const { subscriptionId } = this.state.userInfo;
    const { isInvalid, edited } = this.state;
    const { editMode = false, formLabel } = this.props;
    const { buttonLabel, MainFarmId, userInfo } = this.props;

    return (
      <div className="">
        <Prompt when={edited} message="Changes you made may not be saved." />
        <div className="textRequired">* Required Cells</div>
        <div className="innermainform">
          <p className="loginHeader">{formLabel}</p>
          <Grid container>
            <Grid item xs={12}>
              <InputFiled
                value={lastName}
                label="Last Name"
                type="text"
                name="lastName"
                required
                validations={["minSize", "required", "maxSize"]}
                handleChange={this.handleChange}
                //handleError={this.handleError}
              />
            </Grid>
            <Grid item xs={12}>
              <InputFiled
                value={firstName}
                label="First Name"
                type="text"
                name="firstName"
                required
                validations={["minSize", "required", "maxSize"]}
                handleChange={this.handleChange}
                //handleError={this.handleError}
              />
            </Grid>
            <Grid item xs={12}>
              <InputFiled
                value={username}
                disabled={editMode}
                label="Email/Username"
                type="email"
                name="username"
                required
                validations={["email", "required"]}
                handleChange={this.handleChange}
                //handleError={this.handleError}
              />
            </Grid>
            {!editMode && (
              <Fragment>
                <Grid item xs={12}>
                  <InputFiled
                    value={password}
                    label="Password"
                    type="password"
                    name="password"
                    required
                    validations={["password", "required"]}
                    handleChange={this.handleChange}
                    //handleError={this.handleError}
                  />
                </Grid>
                <Grid item xs={12}>
                  <InputFiled
                    value={confirmPassword}
                    label="Confirm Password"
                    type="password"
                    name="confirmPassword"
                    required
                    validations={["required"]}
                    handleChange={this.handleChange}
                    handleError={this.handleError}
                  />
                  {!this.validateResetForm() && (
                    <FormHelperText>
                      <span className="error" role="alert">
                        Your password confirmation did not match your password
                      </span>
                    </FormHelperText>
                  )}
                </Grid>
              </Fragment>
            )}

            <Grid item xs={12}>
              <Dropdown
                value={role}
                label="Role Type"
                required
                type="text"
                name="role"
                disabled={
                  editMode
                    ? disableEditRole(role)
                    : farmId !== userFarmDetail().id && farmId !== MainFarmId
                }
                options={
                  editMode
                    ? DropdownOptions.editRoleTypes[
                        userInfo ? userInfo.roleName : role
                      ]
                    : DropdownOptions.roleTypes[userDetail().roleName]
                }
                validations={["required"]}
                handleChange={this.handleChange}
                //handleError={this.handleError}
              />
            </Grid>
            {userInfo.roleName === "ACCOUNT_OWNER" && (
              <React.Fragment>
                <FormLabel component="legend" style={{ color: "#000" }}>
                  Modify Subscription Plan
                </FormLabel>

                <Grid container>
                  <RadioGroup
                    aria-label="modifyPlan"
                    name="modifyPlan"
                    value={modifyPlan}
                    onChange={this.handleChange}
                    row
                  >
                    <FormControlLabel
                      value={NO_UPDATE}
                      control={<Radio color="primary" />}
                      label="No Update"
                      labelPlacement="end"
                    />

                    <FormControlLabel
                      value={UPDATE_PLAN}
                      control={<Radio color="primary" />}
                      label="Update Plan"
                      labelPlacement="end"
                    />

                    {!!!userInfo.stripeUser &&
                      userInfo.subscriptionId !== 4 && (
                        <FormControlLabel
                          value={UPGRADE_PLAN}
                          control={<Radio color="primary" />}
                          label="Upgrade Plan"
                          labelPlacement="end"
                        />
                      )}

                    {!userInfo.stripeUser && userInfo.subscriptionId !== 1 && (
                      <FormControlLabel
                        value={RENEW_PLAN}
                        control={<Radio color="primary" />}
                        label="Renew Plan"
                        labelPlacement="end"
                      />
                    )}
                  </RadioGroup>
                </Grid>
              </React.Fragment>
            )}
            <Grid container style={{ justifyContent: "space-between" }}>
              {modifyPlan == UPDATE_PLAN && (
                <React.Fragment>
                  {!this.isEnterpriseUser() && (
                    <Grid item x sm={3}>
                      <InputFiled
                        type="text"
                        value={noOfContracts}
                        label="Contracts"
                        name="noOfContracts"
                        handleChange={this.handleChange}
                      />
                    </Grid>
                  )}
                  {!this.isEnterpriseUser() && (
                    <Grid item x sm={3}>
                      <InputFiled
                        type="text"
                        value={noOfTickets}
                        label="Tickets"
                        name="noOfTickets"
                        handleChange={this.handleChange}
                      />
                    </Grid>
                  )}
                  <Grid item x sm={3}>
                    <InputFiled
                      type="text"
                      value={noOfLogins}
                      label="Login"
                      name="noOfLogins"
                      handleChange={this.handleChange}
                    />
                  </Grid>
                </React.Fragment>
              )}
            </Grid>
            {modifyPlan == UPGRADE_PLAN && (
              <Grid item xs={12}>
                <Dropdown
                  label="Subscription Plan"
                  required
                  type="text"
                  value={subscriptionId}
                  name="subscriptionId"
                  options={availableUpgradeOption}
                  handleChange={this.handleChange}
                  //handleError={this.handleError}
                />
              </Grid>
            )}
          </Grid>
          <div className="signInSection" style={signInSectionStyle}>
            <Link to="/userManagement" style={{ color: "blue" }}>
              Cancel
            </Link>
            <Button
              disabled={
                isInvalid ||
                !this.validateResetForm() ||
                !this.checkUpdatePlanStatus()
              }
              name={buttonLabel}
              styleClass="signIn"
              onclick={this.handleSubmit}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllUsersForm);



// WEBPACK FOOTER //
// ./src/components/private/UserManagement/AllUsersForm.js